type HTMLTextSelectionElement = HTMLInputElement | HTMLTextAreaElement;

function getElement(idOrNode: string | HTMLTextSelectionElement): HTMLTextSelectionElement {
  if (typeof idOrNode === "string") {
    return document.getElementById(idOrNode) as HTMLTextSelectionElement;
  } else {
    return idOrNode;
  }
}

/**
 * Helper function to focus an input element, and place the users cursor at the end of the predefined content
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
export default function focusEndOfInput(idOrNode: string | HTMLTextSelectionElement): void {
  const inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
  } else
    console.warn("No input element detected - make sure you've applied it on the target node.");
}

/**
 * Helper function to focus an input element, and highlight all text inside of it
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
export function focusAllOfInput(idOrNode: string | HTMLTextSelectionElement): void {
  const inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.select();
  } else
    console.warn("No input element detected - make sure you've applied it on the target node.");
}
